// @flow

// Types
import type {
  Fertilizer,
} from 'fc-model-fertilizers/types'

// Libs
import { createSelector } from 'reselect'
import _forEach from 'lodash/forEach'
import _split from 'lodash/split'
import _uniq from 'lodash/uniq'

// Utils
import traverse from 'fc-utils/traverse'

// Constants
import { TREE, BRANCH, PROP_HEFTY_PRIMARY_NUTRIENTS } from 'fc-model-fertilizers'

export default createSelector(
  [traverse([TREE, BRANCH])],
  function (fertilizers: { [number]: Fertilizer }): Array<SoilJob> {
    const primaryNutrients = []
    _forEach(fertilizers, (
      fertilizer: Fertilizer) => {
      _forEach(_split(fertilizer[PROP_HEFTY_PRIMARY_NUTRIENTS], ','),
        (nutrient: string) => { primaryNutrients.push(nutrient) })
    })
    return _uniq(primaryNutrients)
  }
)
